import React from 'react';
import styled from 'styled-components';

import PlusIcon from '../../../components/UI/Icon-SVG/PlusIcon';

const CustomHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 0px 16px;
  width: 100% !important;
  height: 64px;
  border-bottom: 1px solid #d7def3;
`;

const TitleWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const Title = styled.h3`
  font-family: 'Open Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 0;
  margin-right: 10px;
`;

const Badge = styled.div`
  background: #edf2f7;
  width: 22px;
  height: 22px;
  border-radius: 22px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Plus = styled.div`
  width: 32px;
  height: 32px;
  background: #397ef3;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

const ChatListHeader = () => (
  <CustomHeader>
    <TitleWrap>
      <Title>Chat</Title>
      {/* <Badge>3</Badge> */}
    </TitleWrap>
    <Plus>
      <PlusIcon />
    </Plus>
  </CustomHeader>
);

export default ChatListHeader;
